export default "__VITE_ASSET__BdNemJff__"